import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { bpOpscConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `bpOpscConfig` (prop-sourced "Sedang Diproses"
// in-flight panel via config.inFlightFromProps). Page-specific JSX is the
// breadcrumb (headerBanner) and the region-list dropzone line.
// Controller renders "admin/beauty_promoters/bp_opsc/Uploads".
export default function Uploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={bpOpscConfig}
      headerBanner={
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>Beauty Promoters</span>
          <span>/</span>
          <span className="text-ink-body font-medium">BP OPSC</span>
        </div>
      }
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Region: Jakarta 1 · RegBar · RegCen · RegTim · Wipro Unza Indonesia ECOM
        </p>
      }
      {...props}
    />
  )
}
